// Dati DIMOSTRATIVI — non rappresentano immobili reali.
export const COMUNI = ["Corato", "Ruvo di Puglia", "Terlizzi", "Andria", "Margherita di Savoia", "Trani", "Barletta", "Bisceglie"];
export const ZONE = ["Centro", "Periferia", "Contrada", "Zona nuova"];
export const TIPOLOGIE = ["Appartamento", "Villa / Villetta", "Attico", "Casa indipendente", "Bilocale", "Trilocale", "Locale commerciale", "Attività commerciale", "Ufficio", "Capannone / Magazzino", "Terreno", "Garage / Box"];

export const PROPERTIES = [
  {
    id: "attico-terrazzo-corato-centro",
    titolo: "Attico luminoso con ampio terrazzo",
    tipo: "Attico",
    transazione: "vendita",
    prezzo: 295000,
    comune: "Corato",
    zona: "Centro",
    superficie: 130,
    locali: 4,
    camere: 3,
    bagni: 2,
    box: true,
    postoAuto: false,
    ascensore: true,
    balcone: true,
    terrazzo: true,
    giardino: false,
    nuovaCostruzione: false,
    daRistrutturare: false,
    caratteristica: "Terrazzo abitabile di 40 mq",
    etichetta: "In esclusiva",
    classeEnergetica: "B",
    speseCondominiali: 65,
    recente: 6,
    compatibilita: 92,
    coords: { x: 46, y: 40 },
    descrizione:
      "Attico all'ultimo piano con doppia esposizione e un ampio terrazzo abitabile che regala luce a tutti gli ambienti. La zona giorno è open space, affacciata sul terrazzo, mentre la zona notte è composta da tre camere e due bagni. Rifiniture curate e impianti recenti.",
    puntiForza: ["Terrazzo abitabile di 40 mq", "Doppia esposizione, molto luminoso", "Box auto di proprietà", "A pochi passi dal centro"],
    caratteristiche: [
      { label: "Piano", value: "Ultimo (5°)" },
      { label: "Riscaldamento", value: "Autonomo" },
      { label: "Stato", value: "Ottimo" },
      { label: "Anno", value: "2016" },
    ],
    immagini: [
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.unsplash.com/photo-1769845790207-2c022c5eeb40?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.unsplash.com/photo-1661107259637-4e1c55462428?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    ],
  },
  {
    id: "villa-giardino-piscina-corato",
    titolo: "Villa con giardino e piscina",
    tipo: "Villa / Villetta",
    transazione: "vendita",
    prezzo: 640000,
    comune: "Corato",
    zona: "Contrada",
    superficie: 240,
    locali: 6,
    camere: 4,
    bagni: 3,
    box: true,
    postoAuto: true,
    ascensore: false,
    balcone: false,
    terrazzo: true,
    giardino: true,
    nuovaCostruzione: false,
    daRistrutturare: false,
    caratteristica: "Giardino privato con piscina",
    etichetta: "Novità",
    classeEnergetica: "A",
    speseCondominiali: 0,
    recente: 5,
    compatibilita: 88,
    coords: { x: 70, y: 62 },
    descrizione:
      "Elegante villa indipendente immersa nel verde, con giardino privato e piscina. Ampi spazi interni distribuiti su due livelli, zona giorno panoramica e quattro camere. Ideale per chi cerca riservatezza senza rinunciare alla vicinanza alla città.",
    puntiForza: ["Giardino privato con piscina", "Totalmente indipendente", "Ampio garage e posti auto", "Classe energetica A"],
    caratteristiche: [
      { label: "Livelli", value: "2" },
      { label: "Riscaldamento", value: "Autonomo a pavimento" },
      { label: "Stato", value: "Ottimo" },
      { label: "Anno", value: "2019" },
    ],
    immagini: [
      "https://images.unsplash.com/photo-1601560896164-834d6f61ea66?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.unsplash.com/photo-1555667309-35d7a000ec00?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.pexels.com/photos/7214166/pexels-photo-7214166.jpeg?auto=compress&cs=tinysrgb&w=1400",
      "https://images.unsplash.com/photo-1600210491305-7396500b5b31?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    ],
  },
  {
    id: "appartamento-ristrutturato-corato-centro",
    titolo: "Appartamento ristrutturato in centro",
    tipo: "Appartamento",
    transazione: "vendita",
    prezzo: 175000,
    comune: "Corato",
    zona: "Centro",
    superficie: 95,
    locali: 3,
    camere: 2,
    bagni: 1,
    box: false,
    postoAuto: false,
    ascensore: true,
    balcone: true,
    terrazzo: false,
    giardino: false,
    nuovaCostruzione: false,
    daRistrutturare: false,
    caratteristica: "Recentemente ristrutturato",
    etichetta: null,
    classeEnergetica: "C",
    speseCondominiali: 45,
    recente: 4,
    compatibilita: 80,
    coords: { x: 42, y: 46 },
    descrizione:
      "Appartamento completamente ristrutturato con finiture moderne, pronto da abitare. Soggiorno con angolo cottura, due camere e un bagno con doccia. Posizione comodissima, a pochi passi dai principali servizi.",
    puntiForza: ["Ristrutturato di recente", "Pronto da abitare", "Servito da ascensore", "Posizione centrale"],
    caratteristiche: [
      { label: "Piano", value: "2°" },
      { label: "Riscaldamento", value: "Autonomo" },
      { label: "Stato", value: "Ristrutturato" },
      { label: "Anno", value: "1975 (ristr. 2022)" },
    ],
    immagini: [
      "https://images.unsplash.com/photo-1624204386084-dd8c05e32226?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.pexels.com/photos/29012619/pexels-photo-29012619.jpeg?auto=compress&cs=tinysrgb&w=1400",
      "https://images.pexels.com/photos/7587777/pexels-photo-7587777.jpeg?auto=compress&cs=tinysrgb&w=1400",
      "https://images.unsplash.com/photo-1576698483491-8c43f0862543?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    ],
  },
  {
    id: "trilocale-nuova-costruzione-corato",
    titolo: "Trilocale di nuova costruzione",
    tipo: "Trilocale",
    transazione: "vendita",
    prezzo: 210000,
    comune: "Corato",
    zona: "Zona nuova",
    superficie: 85,
    locali: 3,
    camere: 2,
    bagni: 2,
    box: true,
    postoAuto: false,
    ascensore: true,
    balcone: true,
    terrazzo: false,
    giardino: false,
    nuovaCostruzione: true,
    daRistrutturare: false,
    caratteristica: "Classe energetica A, mai abitato",
    etichetta: "Nuova costruzione",
    classeEnergetica: "A",
    speseCondominiali: 50,
    recente: 3,
    compatibilita: 85,
    coords: { x: 58, y: 30 },
    descrizione:
      "Trilocale in nuova palazzina di classe energetica A, mai abitato. Ambienti moderni con ottime finiture, doppio bagno e box auto incluso. Ideale per chi cerca il massimo comfort e bassi consumi.",
    puntiForza: ["Immobile mai abitato", "Classe energetica A", "Doppio bagno", "Box auto incluso"],
    caratteristiche: [
      { label: "Piano", value: "3°" },
      { label: "Riscaldamento", value: "A pavimento" },
      { label: "Stato", value: "Nuovo" },
      { label: "Anno", value: "2024" },
    ],
    immagini: [
      "https://images.pexels.com/photos/18153132/pexels-photo-18153132.jpeg?auto=compress&cs=tinysrgb&w=1400",
      "https://images.unsplash.com/photo-1758548157126-e4c0477f796e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.pexels.com/photos/6782479/pexels-photo-6782479.jpeg?auto=compress&cs=tinysrgb&w=1400",
      "https://images.unsplash.com/photo-1733426107854-ee00a25d72a7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    ],
  },
  {
    id: "bilocale-affitto-corato-centro",
    titolo: "Bilocale arredato in affitto",
    tipo: "Bilocale",
    transazione: "affitto",
    prezzo: 580,
    comune: "Corato",
    zona: "Centro",
    superficie: 60,
    locali: 2,
    camere: 1,
    bagni: 1,
    box: false,
    postoAuto: false,
    ascensore: true,
    balcone: true,
    terrazzo: false,
    giardino: false,
    nuovaCostruzione: false,
    daRistrutturare: false,
    caratteristica: "Arredato, ideale per coppie",
    etichetta: null,
    classeEnergetica: "D",
    speseCondominiali: 40,
    recente: 2,
    compatibilita: 70,
    coords: { x: 40, y: 52 },
    descrizione:
      "Grazioso bilocale arredato in pieno centro, pronto da vivere. Soggiorno con angolo cottura, camera matrimoniale e bagno finestrato. Perfetto per giovani coppie o professionisti.",
    puntiForza: ["Completamente arredato", "In pieno centro", "Servito da ascensore", "Spese contenute"],
    caratteristiche: [
      { label: "Piano", value: "1°" },
      { label: "Riscaldamento", value: "Autonomo" },
      { label: "Arredamento", value: "Arredato" },
      { label: "Contratto", value: "4+4" },
    ],
    immagini: [
      "https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.pexels.com/photos/7214166/pexels-photo-7214166.jpeg?auto=compress&cs=tinysrgb&w=1400",
      "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.unsplash.com/photo-1661107259637-4e1c55462428?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    ],
  },
  {
    id: "casa-indipendente-ristrutturare-corato",
    titolo: "Casa indipendente da ristrutturare",
    tipo: "Casa indipendente",
    transazione: "vendita",
    prezzo: 130000,
    comune: "Corato",
    zona: "Periferia",
    superficie: 150,
    locali: 5,
    camere: 3,
    bagni: 1,
    box: false,
    postoAuto: true,
    ascensore: false,
    balcone: false,
    terrazzo: false,
    giardino: true,
    nuovaCostruzione: false,
    daRistrutturare: true,
    caratteristica: "Grande potenziale, con giardino",
    etichetta: null,
    classeEnergetica: "G",
    speseCondominiali: 0,
    recente: 1,
    compatibilita: 65,
    coords: { x: 30, y: 68 },
    descrizione:
      "Casa indipendente su unico livello con giardino, da ristrutturare completamente. Ottima base per realizzare l'abitazione su misura, in zona tranquilla e ben collegata. Grandi volumi e ampio spazio esterno.",
    puntiForza: ["Totalmente indipendente", "Ampio giardino privato", "Grande potenziale di rivalutazione", "Zona tranquilla"],
    caratteristiche: [
      { label: "Livelli", value: "1" },
      { label: "Riscaldamento", value: "Da realizzare" },
      { label: "Stato", value: "Da ristrutturare" },
      { label: "Anno", value: "1968" },
    ],
    immagini: [
      "https://images.unsplash.com/photo-1691425700585-c108acad6467?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.unsplash.com/photo-1579625462317-e1475a3906dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.pexels.com/photos/29012619/pexels-photo-29012619.jpeg?auto=compress&cs=tinysrgb&w=1400",
    ],
  },
];

export const getProperty = (id) => PROPERTIES.find((p) => p.id === id);

export const formatPrezzo = (p) => {
  const n = new Intl.NumberFormat("it-IT").format(p.prezzo);
  return p.transazione === "affitto" ? `€ ${n}/mese` : `€ ${n}`;
};

export const formatEuro = (n) => `€ ${new Intl.NumberFormat("it-IT").format(Math.round(n))}`;
